module.exports = __webpack_public_path__ + "static/media/MOTIVATION_EXT_POS.88c40f7f.md";